import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCondition = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15.4726 1.95871L1.96117 15.4702C1.63624 15.7951 1.63624 16.3201 1.96117 16.6451L15.4726 30.1565C15.7976 30.4815 16.3226 30.4815 16.6475 30.1565L30.159 16.6451C30.4839 16.3201 30.4839 15.7951 30.159 15.4702L16.6475 1.95871C16.3226 1.63377 15.7976 1.63377 15.4726 1.95871ZM28.1029 16.0576L16.0601 28.1004L4.01726 16.0576L16.0601 4.0148L28.1029 16.0576Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.7345 9.22868L9.23124 15.7319C9.07484 15.8883 9.07484 16.141 9.23124 16.2974L15.7345 22.8006C15.8909 22.957 16.1436 22.957 16.3 22.8006L22.8032 16.2974C22.9596 16.141 22.9596 15.8883 22.8032 15.7319L16.3 9.22868C16.1436 9.07228 15.8909 9.07228 15.7345 9.22868Z",
		fill: "currentColor"
	})]
});
export default SvgCondition;
